import LaunchIcon from '@mui/icons-material/Launch';
import React from 'react';
import { Link } from 'react-router-dom';

interface EmbeddingsLinkProps {
  upc: string;
  chainId: number;
  storeId?: number;
  storeName?: string;
  itemNumber?: string;
}

export const EmbeddingsLink: React.FC<EmbeddingsLinkProps> = ({
  upc,
  chainId,
  storeId,
  storeName,
  itemNumber,
}) => {
  const params = new URLSearchParams();
  params.append('chain_id', chainId.toString());
  params.append('upc', upc);

  if (storeId) {
    params.append('store_id', storeId.toString());
  }
  if (storeName) {
    params.append('store_name', storeName);
  }
  if (itemNumber) {
    params.append('item_number', itemNumber);
  }

  return (
    <Link
      to={`/embeddings/detail?${params.toString()}`}
      target="_blank"
      className="inline-flex items-center gap-1 px-3 py-1.5 text-xs font-medium text-white bg-indigo-600 rounded hover:bg-indigo-700 transition-colors"
      title="View embeddings for this UPC"
    >
      <LaunchIcon sx={{ fontSize: 12 }} />
      Embeddings
    </Link>
  );
};
